import React from 'react';
import { Link } from 'react-router-dom';

const TeacherCard = ({ 
  teacher,
  isSelected = false,
  onSelect = null,
  showActions = true
}) => {
  const { id, name, type, picture, specialty, level, biography, teachingStyle } = teacher;

  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 ${
      isSelected ? 'ring-2 ring-blue-500' : ''
    }`}>
      <div className="p-4">
        <div className="flex flex-col items-center">
          <div className="h-32 w-32 mb-4">
            {picture ? (
              <img
                className="h-32 w-32 rounded-full object-cover"
                src={picture}
                alt={name}
              />
            ) : (
              <div className="h-32 w-32 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                <span className="text-3xl font-bold text-white">
                  {name.charAt(0)}
                </span>
              </div>
            )}
          </div>
          
          <div className="text-center w-full">
            <h3 className="text-lg font-bold text-gray-900 mb-2">{name}</h3>
            
            <div className="flex flex-wrap justify-center gap-2 mb-3">
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                type === 'PREMIUM'
                  ? 'bg-purple-100 text-purple-800'
                  : type === 'CUSTOM'
                  ? 'bg-blue-100 text-blue-800'
                  : 'bg-gray-100 text-gray-800'
              }`}>
                {type}
              </span>
              <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                {level}
              </span>
            </div>
            
            <p className="text-sm text-gray-600 mb-2 font-medium">{specialty}</p>
            
            {teachingStyle && (
              <p className="text-xs text-gray-500 mb-2">Style: {teachingStyle}</p>
            )}
            
            {biography && (
              <p className="text-xs text-gray-600 line-clamp-3 mt-2">{biography}</p>
            )}
          </div>
        </div>
      </div>
      
      {showActions && (
        <div className="bg-gray-50 px-4 py-3 flex justify-center gap-2">
          <Link
            to={`/teacher/${id}`}
            className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors"
          >
            View Profile
          </Link>
          {onSelect && (
            <button
              onClick={() => onSelect(teacher)}
              className="px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg text-sm font-medium hover:from-blue-600 hover:to-purple-700 transition-all"
            >
              {isSelected ? 'Selected' : 'Select Teacher'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default TeacherCard;

